export enum EMPLOYEE_MEMBER_TYPE {
  INTERNAL = 'internalMember',
  EXTERNAL = 'externalMember',
}

export enum ACCOUNT_STATUS {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}
export enum USER_TYPE {
  BIM_DATA_PLATFORM_INTERNAL = 'BIM_DATA_PLATFORM_INTERNAL',
  BIM_DATA_PLATFORM_EXTERNAL = 'BIM_DATA_PLATFORM_EXTERNAL',
  NSPT2_0 = 'NSPT2.0',
  DENODO = 'DENODO',
  DESIGNPORTAL = 'DESIGNPORTAL', //thiết kế
}

export const UserRoleHidden = {
  PUBLISHED: 'Estimate' as const,
  UNPUBLISHED: 'Rough Estimate Support' as const,
} as const;

export enum USER_ROLE {
  BIM_DATA_PLATFORM_ADMIN = '001',
  BIM_DATA_PLATFORM_USER = '002',
}
